import React from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  progressStyles: {
    position: "absolute",
    top: "50%",
  },
}));

const LoadingScreen = ({ loading, loaderColor = "primary" }) => {
  const classes = useStyles();
  console.log("loading status1", loading);
  return (
    <Grid container direction="row" justify="center">
      <CircularProgress
        color={loaderColor}
        className={classes.progressStyles}
      />
    </Grid>
  );
};

export default LoadingScreen;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  p: 4,
};
export const LoadingScreen2 = ({ loading, loaderColor = "primary" }) => {
  const classes = useStyles();
  console.log("loading status", loading);
  return (
    <>
      {" "}
      <Modal
        open={loading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container direction="row" justify="center">
            <CircularProgress
              color={loaderColor}
              className={classes.progressStyles}
            />
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

